import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN,INDEX_MAIN_PAGE_PATH,DM_MENU_CACHE_KEY } from '@/store/mutation-types'
import { generateIndexRouter } from "@/utils/util"

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user/login', '/user/register', '/user/register-result','/user/alteration'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar

  // 兼容两种存储：勾选“记住我”token 在 localStorage，未勾选在 sessionStorage
  if (Vue.ls.get(ACCESS_TOKEN) || sessionStorage.getItem(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({ path: INDEX_MAIN_PAGE_PATH })
      NProgress.done()
    } else {
      if (store.getters.permissionList.length === 0) {
        // 优先使用会话内缓存的菜单数据,F5 刷新时免拉权限接口,消除白屏闪屏
        let cachedMenu = null
        try {
          const cachedStr = sessionStorage.getItem(DM_MENU_CACHE_KEY)
          cachedMenu = cachedStr ? JSON.parse(cachedStr) : null
        } catch (e) {
          cachedMenu = null
        }
        if (cachedMenu && cachedMenu.length) {
          store.commit('SET_PERMISSIONLIST', cachedMenu)
          const constRoutes = generateIndexRouter(cachedMenu)
          store.dispatch('UpdateAppRouter', { constRoutes }).then(() => {
            router.addRoutes(store.getters.addRouters)
            // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            next({ ...to, replace: true })
          })
        } else {
          store.dispatch('GetPermissionList').then(res => {
                const menuData = res.result.menu;
                //console.log(res.message)
                if (menuData === null || menuData === "" || menuData === undefined) {
                  return;
                }
                let constRoutes = [];
                constRoutes = generateIndexRouter(menuData);
                // 添加主界面路由
                store.dispatch('UpdateAppRouter',  { constRoutes }).then(() => {
                  // 根据roles权限生成可访问的路由表
                  // 动态添加可访问路由表
                  router.addRoutes(store.getters.addRouters)
                  const redirect = decodeURIComponent(from.query.redirect || to.path)
                  if (to.path === redirect) {
                    // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                    next({ ...to, replace: true })
                  } else {
                    // 跳转到目的路由
                    next({ path: redirect })
                  }
                })
              })
            .catch(() => {
              /* notification.error({
                  message: '系统提示',
                  description: '请求用户信息失败，请重试！'
                })*/
                store.dispatch('Logout').then(() => {
                  next({ path: '/user/login', query: { redirect: to.fullPath } })
                })
            })
        }
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
